/**
 * This enum contains all integration platforms compatible with Class.
 */

export enum IntegrationTypes {
    Blackboard = 'Blackboard',
    Docebo = 'Docebo',
    CSOD = 'CSOD',
    Moodle = 'Moodle',
    OpenLMS = 'OpenLMS',
    Canvas = 'Canvas',
    Sakai = 'Sakai',
    D2L = 'D2L',
    Schoology = 'Schoology',
    Other = 'other',
    IMS = 'IMS'
}
